import { Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { IoMdClose } from 'react-icons/io';

import { Typography } from '@design-system';
import './showApiErrorToast.scss';

export type showApiErrorToastType = {
    message: string;
};

export const showApiErrorToast = ({ message }: showApiErrorToastType) => {
    toast(
        <div id="api-error-toast" style={{ display: 'flex', alignItems: 'center' }}>
            <div className="icon-container">
                <IoMdClose />
            </div>
            <Typography intrinsic="h1" variant="sub" className="ml-small-spacing">
                {message}
            </Typography>
        </div>,
        {
            position: 'top-left',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            theme: 'colored',
            transition: Slide,
            draggableDirection: 'y',
            draggablePercent: 100,
            className: 'api-error-toast'
        }
    );
};
